import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {Currency} from "../currency/Currency";
import {RewardGeneratorModel} from "../reward-generator/RewardGeneratorModel";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";

export class RewardPackageConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(RewardPackageConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(RewardPackageConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._name = null;
        this._guard = null;

        this._money = [];
        this._generators = [];
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get money() {
        return this._money;
    }

    set money(value) {
        this._money = value;
    }

    get generators() {
        return this._generators;
    }

    set generators(value) {
        this._generators = value;
    }

    valid() {
        if (typeof this.name !== "string" || !this.name.trim()) {
          return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.money && this.money.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.generators && this.generators.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.money.length === 0 && this.generators.length === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RewardPackageConfig());
        } else if (target instanceof RewardPackageConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RewardPackageConfig, {
    _name: alias("name", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _money: alias("money", list(Currency.schema())),
    _generators: alias("generators", list(RewardGeneratorModel.schema()))
});
